import script from "./FileView.vue?vue&type=script&setup=true&lang=js"
export * from "./FileView.vue?vue&type=script&setup=true&lang=js"

import "./FileView.vue?vue&type=style&index=0&id=9a8f51a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9a8f51a2"]])

export default __exports__